<template>
  <div class="podcast-page">
    <section class="hero">
      <div class="container">
        <div class="hero-content">
          <h1>The Ascent Podcast</h1>
          <p>Insights and conversations from industry leaders.</p>
        </div>
      </div>
    </section>

    <section class="podcasts">
      <div class="container">
        <div class="podcast-list">
          <div class="podcast">
            <img src="@/assets/images/podcast1.jpg" alt="Podcast Episode" />
            <div class="podcast-content">
              <h2>Episode 42: Digital Transformation in Construction</h2>
              <p class="meta">Host: John Smith | Guest: Jane Doe, CTO of BuildTech</p>
              <p>In this episode, we explore how construction companies are leveraging new technologies to streamline operations and improve project outcomes.</p>
              <button class="listen-btn">Listen Now</button>
            </div>
          </div>

          <div class="podcast">
            <img src="@/assets/images/podcast2.jpg" alt="Podcast Episode" />
            <div class="podcast-content">
              <h2>Episode 41: Building High-Performance Teams</h2>
              <p class="meta">Host: John Smith | Guest: Michael Johnson, HR Director</p>
              <p>Learn how successful contractors attract, develop, and retain top talent in today's competitive labor market.</p>
              <button class="listen-btn">Listen Now</button>
            </div>
          </div>

          <div class="podcast">
            <img src="@/assets/images/podcast3.jpg" alt="Podcast Episode" />
            <div class="podcast-content">
              <h2>Episode 40: Financial Management Best Practices</h2>
              <p class="meta">Host: John Smith | Guest: Sarah Williams, CFO</p>
              <p>Discover the key financial metrics that matter most and how to use them to drive better business decisions.</p>
              <button class="listen-btn">Listen Now</button>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="subscribe">
      <div class="container">
        <h2>Never Miss an Episode</h2>
        <p>Subscribe to The Ascent Podcast on your favorite platform.</p>
        <div class="platforms">
          <button class="platform-btn">Apple Podcasts</button>
          <button class="platform-btn">Spotify</button>
          <button class="platform-btn">Google Podcasts</button>
          <button class="platform-btn">Stitcher</button>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'PodcastPage'
}
</script>

<style scoped>
.hero {
  background-image: url('@/assets/images/podcast-hero.jpg');
  background-size: cover;
  background-position: center;
  color: white;
  padding: 8rem 0;
  text-align: center;
  position: relative;
  width: 100%;
}

.hero::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 1;
}

.hero-content {
  position: relative;
  z-index: 2;
  max-width: 800px;
  margin: 0 auto;
  padding: 0 1rem;
}

.hero h1 {
  font-size: 3rem;
  margin-bottom: 1rem;
}

.hero p {
  font-size: 1.2rem;
}

.podcasts {
  background-color: black;
  color: white;
  padding: 6rem 0;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1rem;
}

.podcast-list {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 3rem;
}

.podcast {
  background-color: #111;
  border-radius: 8px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.podcast img {
  width: 100%;
  height: 200px;
  object-fit: cover;
}

.podcast-content {
  padding: 1.5rem;
  flex: 1;
  display: flex;
  flex-direction: column;
}

.podcast-content h2 {
  font-size: 1.5rem;
  margin-bottom: 0.5rem;
}

.meta {
  color: #aaa;
  font-size: 0.9rem;
  margin-bottom: 1rem;
}

.podcast-content p {
  font-size: 1rem;
  line-height: 1.6;
  margin-bottom: 1.5rem;
  flex: 1;
}

.listen-btn {
  background-color: var(--primary-color);
  color: white;
  border: none;
  padding: 0.5rem 1.5rem;
  border-radius: 25px;
  cursor: pointer;
  font-size: 0.9rem;
  transition: background-color 0.3s;
  align-self: flex-start;
}

.listen-btn:hover {
  background-color: var(--secondary-color);
}

.subscribe {
  background-color: var(--bg-light);
  color: black;
  padding: 6rem 0;
  text-align: center;
}

.subscribe h2 {
  font-size: 2.5rem;
  margin-bottom: 1rem;
}

.subscribe p {
  font-size: 1.1rem;
  margin-bottom: 2rem;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
  padding: 0 1rem;
}

.platforms {
  display: flex;
  justify-content: center;
  gap: 1rem;
  flex-wrap: wrap;
}

.platform-btn {
  background-color: black;
  color: white;
  border: 1px solid #333;
  padding: 0.75rem 1.5rem;
  border-radius: 25px;
  cursor: pointer;
  font-size: 0.9rem;
  transition: all 0.3s;
}

.platform-btn:hover {
  background-color: var(--primary-color);
  border-color: var(--primary-color);
}

@media (max-width: 768px) {
  .hero h1 {
    font-size: 2rem;
  }
}
</style>